import React, { PureComponent } from 'react';
import { translate } from '../../../base/i18n/functions';
import { isLocalParticipantModerator } from '../../../base/participants/functions';
import { connect } from '../../../base/redux/functions';
import Switch from '../../../base/ui/components/web/Switch';
import { isInBreakoutRoom } from '../../../breakout-rooms/functions';
import { toggleLobbyMode } from '../../actions';
// CUSTOM
// @ts-ignore
import { getBaseConfig } from '../../../customise/Utils';
// @ts-ignore
import { FEATURE_CUSTOM_REDUX } from '../../../customise/constant';
// @ts-ignore
import axios from 'axios';
// @ts-ignore
import Config from '../../../customise/config';
// @ts-ignore
const { socket_endpoint } = Config;
// @ts-ignore
import { apiVersion } from '../../../customise/welcome-dashboard/Utils';
// @ts-ignore
import { setLobbyStatus } from '../../../customise/redux/tool-webjam/actions';
let getLocalAuth = localStorage.getItem("auth");
if (getLocalAuth) {
    getLocalAuth = JSON.parse(getLocalAuth);
}
/**
 * Implements a security feature section to control lobby mode.
 */
class LobbySection extends PureComponent {
    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            lobbyEnabled: props._lobbyEnabled
        };
        this._onToggleLobby = this._onToggleLobby.bind(this);
    }
    /**
     * Implements React's {@link Component#getDerivedStateFromProps()}.
     *
     * @inheritdoc
     */
    static getDerivedStateFromProps(props, state) {
        if (props._lobbyEnabled !== state.lobbyEnabled) {
            return {
                lobbyEnabled: props._lobbyEnabled
            };
        }
        return null;
    }
    /**
     * Implements {@code PureComponent#render}.
     *
     * @inheritdoc
     */
    render() {
        const { _visible, t } = this.props;
        if (!_visible) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: 'lobby-section' },
                React.createElement("p", { className: 'description', role: 'banner' }, t('lobby.enableDialogText')),
                React.createElement("div", { className: 'control-row' },
                    React.createElement("label", { htmlFor: 'lobby-section-switch' }, t('lobby.toggleLabel')),
                    React.createElement(Switch, { checked: this.state.lobbyEnabled, id: 'lobby-section-switch', onChange: this._onToggleLobby }))),
            React.createElement("div", { className: 'separator-line' })));
    }
    /**
     * Callback to be invoked when the user toggles the lobby feature on or off.
     *
     * @returns {void}
     */
    _onToggleLobby() {
        // CUSTOM
        const lobbyChange = getBaseConfig("lobbyChange");
        if (lobbyChange == false) {
            return false;
        }
        // END
        const newValue = !this.state.lobbyEnabled;
        this.setState({
            lobbyEnabled: newValue
        });
        this.props.dispatch(toggleLobbyMode(newValue));
        // CUSTOM
        this.props.dispatch(setLobbyStatus(newValue));
        // HIT API TO SAVE AT LOCAL
        const { userLoginData, roomorIpAddress } = this.props;
        if (getLocalAuth) {
            const config = {
                headers: {
                    // @ts-ignore
                    'Authorization': `Bearer ${getLocalAuth.token}`,
                    'content-type': 'application/json'
                }
            };
            let obj = {
                groupName: roomorIpAddress,
                email: userLoginData?.email,
                userId: userLoginData?.user?.id,
                lobby: newValue
            };
            let url = `${socket_endpoint + apiVersion}/update_owner_Room`;
            axios.put(url, obj, config).then(response => {
                console.log("update_owner_Room successs =>", response);
            }).catch(error => {
                console.log("update_owner_Room error =>", error);
            });
        }
        else {
            console.log("Token expired =>");
        }
        // END
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { conference } = state['features/base/conference'];
    const { hideLobbyButton } = state['features/base/config'];
    return {
        _lobbyEnabled: state['features/lobby'].lobbyEnabled,
        _visible: conference?.isLobbySupported() && isLocalParticipantModerator(state)
            && !hideLobbyButton && !isInBreakoutRoom(state),
        // CUSTOM
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        // END
    };
}
export default translate(connect(mapStateToProps)(LobbySection));
